export default function DefaultAvatar() {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.121216 14.5254C0.121216 16.3813 1.58048 17.885 3.379 17.885C4.94413 17.885 6.25061 16.7461 6.5646 15.2288L2.69689 11.2402C1.22559 11.564 0.121216 12.9113 0.121216 14.5254Z"
        fill="url(#paint0_linear_3876_43461)"
      />
      <path
        d="M6.5646 15.2271C6.24941 16.7481 4.94293 17.8845 3.3778 17.8845C1.57808 17.8845 0.121216 16.3808 0.121216 14.5261C0.121216 14.5125 0.121216 14.4951 0.124825 14.4814C0.178961 16.289 1.61296 17.7331 3.379 17.7331C4.90323 17.7331 6.18084 16.655 6.53573 15.1973L6.5658 15.2283L6.5646 15.2271Z"
        fill="#FFECB8"
      />
      <path
        d="M15.5187 11.924C15.4886 12.156 15.3876 12.3768 15.2143 12.5567L10.3685 17.5564C9.93907 17.9956 9.24974 17.9956 8.82026 17.5564L5.42293 14.0492L0.569936 9.04948C0.144067 8.60658 0.144067 7.8957 0.569936 7.4528L2.01717 5.96407L5.41932 2.4556C5.64308 2.22485 5.94143 2.11443 6.23978 2.12808C6.50083 2.14173 6.76309 2.25214 6.964 2.45684L15.2143 10.965C15.4694 11.228 15.5692 11.5841 15.5187 11.9252V11.924Z"
        fill="url(#paint1_linear_3876_43461)"
      />
      <path
        d="M15.5187 11.9238C15.4489 11.6993 15.3238 11.4921 15.1506 11.3159L6.23979 2.12793C6.50085 2.14158 6.76311 2.25199 6.96401 2.45669L15.2143 10.9648C15.4694 11.2278 15.5692 11.5839 15.5187 11.9251V11.9238Z"
        fill="#89C632"
      />
      <path
        d="M9.35199 17.8576C9.1571 17.813 8.97304 17.7125 8.82266 17.5574L0.572336 9.04926C0.253536 8.7205 0.170527 8.24038 0.328123 7.83594C0.284814 8.22673 0.408725 8.63365 0.699857 8.93512L6.46955 14.8851L9.35079 17.8564L9.35199 17.8576Z"
        fill="#BBE87C"
      />
      <path
        d="M23.5585 10.9635L15.3081 2.45531C14.8811 2.0149 14.1893 2.0149 13.7623 2.45531L10.3625 5.9613L15.2131 10.9635C15.6402 11.4039 15.6402 12.1172 15.2131 12.5577L13.7671 14.0489L17.1668 17.5549C17.5939 17.9953 18.2856 17.9953 18.7127 17.5549L23.5585 12.5577C23.9855 12.1172 23.9855 11.4039 23.5585 10.9635Z"
        fill="url(#paint2_linear_3876_43461)"
      />
      <path
        d="M17.6962 17.8576C17.5013 17.813 17.3172 17.7125 17.1668 17.5574L8.91772 9.04926C8.59892 8.7205 8.51591 8.24038 8.67351 7.83594C8.6302 8.22673 8.75411 8.63365 9.04524 8.93512L14.8149 14.8851L17.6962 17.8564V17.8576Z"
        fill="#91CFF9"
      />
      <path
        d="M15.2131 10.9631L10.3625 5.96094L8.9165 7.45216C8.48942 7.89258 8.48942 8.60593 8.9165 9.04635L13.7671 14.0485L15.2131 12.5573C15.6402 12.1169 15.6402 11.4035 15.2131 10.9631Z"
        fill="url(#paint3_linear_3876_43461)"
      />
      <path
        d="M13.8886 13.9276L13.7683 14.048L8.92011 9.04828C8.60131 8.71952 8.51831 8.2394 8.6759 7.83496C8.63259 8.22576 8.7565 8.63268 9.04763 8.93415L13.8898 13.9276H13.8886Z"
        fill="#2EC4FF"
      />
      <path
        d="M3.37898 11.166C3.14439 11.166 2.91702 11.1921 2.69687 11.2405L6.56458 15.229C6.6115 15.002 6.63677 14.7675 6.63677 14.5256C6.63677 12.6696 5.1787 11.166 3.37898 11.166Z"
        fill="#B3E50A"
      />
      <path
        d="M23.8604 11.9221C23.7907 11.6976 23.6655 11.4904 23.4923 11.3142L14.5815 2.125C14.8426 2.13865 15.1048 2.24906 15.3057 2.45376L23.5561 10.9619C23.8111 11.2249 23.911 11.581 23.8604 11.9221Z"
        fill="#3486E8"
      />
      <path
        d="M6.60188 15.02C6.59226 15.0894 6.57902 15.1577 6.56459 15.2272L6.53451 15.1961L2.69807 11.2398C2.76544 11.2262 2.83161 11.2125 2.90259 11.2051L6.60188 15.02Z"
        fill="#B3CC21"
      />
      <path
        d="M15.5331 11.7504C15.5331 11.8087 15.5259 11.8682 15.5199 11.9228C15.4501 11.6983 15.325 11.4911 15.1518 11.3149L10.1628 6.17007L10.3637 5.96289L15.2119 10.9626H15.2155C15.2697 11.0184 15.3166 11.0767 15.3527 11.1387C15.3924 11.1971 15.426 11.2628 15.4537 11.3323V11.336C15.4802 11.4018 15.5006 11.4675 15.5139 11.537V11.5444C15.5271 11.6139 15.5343 11.6821 15.5343 11.7516L15.5331 11.7504Z"
        fill="#36C0EA"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3876_43461"
          x1="2.39372"
          y1="15.8727"
          x2="4.6473"
          y2="12.9756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB800" />
          <stop offset="0.89" stopColor="#FFD878" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3876_43461"
          x1="12.3198"
          y1="15.2029"
          x2="3.01878"
          y2="4.93785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74D400" />
          <stop offset="0.52" stopColor="#A1FA14" />
          <stop offset="1" stopColor="#B7FB0A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3876_43461"
          x1="21.0057"
          y1="14.8813"
          x2="12.0823"
          y2="6.30167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D96E6" />
          <stop offset="0.91" stopColor="#33A8F7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3876_43461"
          x1="17.938"
          y1="16.294"
          x2="9.07764"
          y2="7.37356"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stopColor="#2D96E6" />
          <stop offset="0.15" stopColor="#2E97E6" />
          <stop offset="0.59" stopColor="#4DC6F8" />
          <stop offset="0.81" stopColor="#5AD8FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
